/**
 * data-dropdown — Generic dropdown menu component
 *
 * Attributes:
 *   data-dropdown          Wrapper element
 *   data-dropdown-trigger  Toggle trigger button
 *   data-dropdown-menu     Menu to show/hide
 */

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-dropdown]').forEach(dropdown => {
        const trigger = dropdown.querySelector('[data-dropdown-trigger]')
        const menu = dropdown.querySelector('[data-dropdown-menu]')
        if (!trigger || !menu) return

        trigger.addEventListener('click', e => {
            e.stopPropagation()

            // Close all other open dropdowns first
            document.querySelectorAll('[data-dropdown-menu]').forEach(otherMenu => {
                if (otherMenu !== menu) {
                    otherMenu.setAttribute('hidden', '')
                }
            })

            if (menu.hasAttribute('hidden')) {
                menu.removeAttribute('hidden')
            } else {
                menu.setAttribute('hidden', '')
            }
        })
    })

    // Close all dropdowns when clicking outside
    document.addEventListener('click', e => {
        if (!e.target.closest('[data-dropdown]')) {
            document.querySelectorAll('[data-dropdown-menu]').forEach(menu => {
                menu.setAttribute('hidden', '')
            })
        }
    })

    // Close all dropdowns on Escape
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            document.querySelectorAll('[data-dropdown-menu]').forEach(menu => {
                menu.setAttribute('hidden', '')
            })
        }
    })
})
